import { render, staticRenderFns } from "./TravelInfoForm.vue?vue&type=template&id=22c96389&"
import script from "./TravelInfoForm.vue?vue&type=script&lang=js&"
export * from "./TravelInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports